import { useEffect, useState } from 'react';
import ApiService from '../services/ApiService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function TableLeaderBoard({ survivorId }) {
  const [data, setData] = useState([]);
  const [jornadas, setJornadas] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await ApiService.get(`/leaderboard/jornadas-picks?survivorId=${survivorId}`);

      if (res) {
        setData(res.dataLeaderBoard || []);
        setJornadas(res.jornadas || []);
      } else {
        setData([]);
        setJornadas([]);
      }
    } catch (error) {
      console.error('Error al cargar leaderboard:', error);
      setData([]);
      setJornadas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [survivorId]);

  function formatText(texto) {
    const len = texto.length;
    if (len <= 2) return texto;
    if (len <= 4) return texto[0] + '*'.repeat(len - 2) + texto[len - 1];
    return texto.slice(0, 2) + '*'.repeat(len - 4) + texto.slice(-2);
  }

  const renderPick = (pickData) => {
    // pickData ahora es el objeto completo desde el backend: 
    // { acierto: number | null, logo_url: string | null, nombre_equipo: string | null, numero_jornada: number | null }
    const acierto = pickData?.acierto;
    const logoUrl = pickData?.logo_url;
    const nombreEquipo = pickData?.nombre_equipo;
    const numeroJornada = pickData?.numero_jornada;
    
    let style = {
      padding: '4px',
      borderRadius: '4px',
      textAlign: 'center',
      minWidth: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
    };

    // Asignación de color de fondo
    if (acierto === 1) {
      style.backgroundColor = '#14b624'; // Verde  (Acierto)
    } else if (acierto === 0) {
      style.backgroundColor = '#f41c2eff'; // Rojo  (Fallo)
    } else {
      style.backgroundColor = '#f2f2f2'; // Gris (Pendiente/No pick)
    }

    let titleText = 'Pendiente/No hay pick';
    
    if (logoUrl) {
      // Solo si hay pick (tenemos logoUrl), definimos el resultado y el detalle
      const resultado = acierto === 1 ? 'Acierto' : acierto === 0 ? 'Fallo' : 'Pendiente';
      const jornadaStr = numeroJornada ? `J${numeroJornada}` : '';
      
      // Formato deseado: Resultado: Jornada - NombreEquipo
      titleText = `${resultado}: ${jornadaStr} - ${nombreEquipo}`;
    }

    // Si hay URL de logo, mostramos la imagen
    if (logoUrl) {
      return (
        <div style={style} title={titleText}> {/* Usamos el titleText detallado */}
          <img 
            src={'https://aicapitan.com/Survivor/admin/controllers/'+logoUrl} 
            alt={`Logo de ${nombreEquipo}`} 
            style={{ 
              maxWidth: '90%', 
              maxHeight: '90%', 
              objectFit: 'contain' 
            }}
          />
        </div>
      );
    }

    // Si no hay pick (muestra '-')
    return (
      <span 
        style={{
          ...style,
          color: '#6c757d', 
          fontWeight: 'bold' 
        }} 
        title={titleText} // Usamos el titleText (que será 'Pendiente/No hay pick')
      >
        -
      </span>
    );
  };


  return (
    <div>
      <div style={{ overflowX: 'auto' }}>
        <table className="table table-bordered table-striped">
          <thead className="table-light sticky-header">
            <tr>
              {/* Encabezados Fijos */}
              <th style={{ minWidth: '150px' }}>Usuario</th>
              <th style={{ minWidth: '80px' }}>Vidas</th>

              {/* Encabezados Dinámicos de Jornadas */}
              {jornadas.map((jornada) => (
                <th key={jornada.id} className="text-center" style={{ minWidth: '60px' }}>
                  J{jornada.numero}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              // Esqueleto de carga dinámico
              Array.from({ length: 5 }).map((_, i) => (
                <tr key={i}>
                  <td>...cargando</td>
                  <td></td>
                  {jornadas.map((j) => <td key={j.id}></td>)}
                </tr>
              ))
            ) : data.length > 0 ? (
              data.map((jugador) => (
                <tr key={jugador.jugador_id}>
                  {/* Datos del Jugador */}
                  <td>{formatText(jugador.nombre_jugador)}</td>
                  <td>{jugador.vidas_restantes}</td>

                  {/* Celdas de Aciertos/Fallos Dinámicos */}
                  {jornadas.map((jornada) => {
                    // Obtiene el OBJETO pick para la jornada (incluye acierto, logo_url, nombre_equipo, num_jornada)
                    const pickData = jugador.picks[jornada.numero];
                    return (
                      <td key={jornada.id} className="text-center">
                        {renderPick(pickData)} {/* Se pasa el objeto completo */}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2 + jornadas.length} className="text-center">No hay datos disponibles</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}